import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Feedback';

const FeedbackApi: any = baseApi(endpoint);

export default FeedbackApi;